var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingleGrantorUponDeathIcon = function SvgSingleGrantorUponDeathIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 80,
    fill: "none",
    viewBox: "0 0 48 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 80,
    fill: "#3F6086",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 6,
    x: 10,
    y: 65,
    fill: "#FACC15",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 55h3l-6 6-6-6h3V19h6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.183 15q-.867 0-1.504-.367a2.53 2.53 0 0 1-.979-1.042q-.346-.67-.346-1.579 0-.912.35-1.587a2.56 2.56 0 0 1 .991-1.05Q17.333 9 18.184 9q.846 0 1.479.376.633.37.983 1.05.35.674.35 1.586 0 .905-.346 1.579a2.5 2.5 0 0 1-.975 1.042Q19.04 15 18.183 15m0-1.26q.322 0 .572-.161.254-.166.395-.537.145-.375.145-1.006 0-.65-.145-1.037-.141-.392-.395-.566a.98.98 0 0 0-.572-.173 1 1 0 0 0-.577.173q-.25.174-.395.566-.145.387-.145 1.037 0 .63.145 1.006.146.37.395.537.255.16.577.161m4.023-4.66h-.322v5.84h2.087q1.032 0 1.7-.38.67-.38.996-1.042.327-.666.327-1.518 0-.828-.315-1.466a2.33 2.33 0 0 0-.983-1.013q-.665-.375-1.717-.412a13 13 0 0 0-.512-.008 27 27 0 0 0-.665 0zm1.245 4.604v-3.368h.569q.399 0 .7.186.303.186.468.553.17.364.17.9 0 .634-.214 1.014-.21.38-.52.549-.306.166-.604.166zm3.724 1.235 2.063-5.838h1.604l2.064 5.838h-1.548l-.387-1.13h-1.837l-.395 1.13zm2.29-2.471h1.152l-.573-1.865zM38 9.081l-2.075 3.407v2.431h-1.572v-2.43L32.3 9.08h1.693l1.153 2.075 1.14-2.075zm-28 0v1.38h1.652v4.458h1.572v-4.458h1.668v-1.38z",
    clipRule: "evenodd"
  })));
};
export default SvgSingleGrantorUponDeathIcon;